import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { Button } from "@progress/kendo-react-buttons";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import AlertBox from "../../components/common/AlertBox";
import {
  GridCellProps,
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
} from "@progress/kendo-react-grid";
import {
  HeaderThElement,
  PagerTargetEvent,
} from "@progress/kendo-react-data-tools";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import { MdDelete } from "react-icons/md";
import { Switch } from "@progress/kendo-react-inputs";
import {
  OpportunityTypeActiveInactive,
  deleteOpportunityType,
  getAllOpportunityType,
} from "./services/opportunityType.services";
import AppDrawer from "../../components/drawer/Drawer";
import CreateOpportunityType from "./CreateOpportunityType";
import ButtonCreate from "../../components/drawer/ButtonCreate";
import {
  clearOpportunityTypeID,
  setOpportunityTypeID,
} from "./opportunityTypeSlice";
import ButtonEdit from "../../components/drawer/ButtonEdit";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import { checkAcessRights } from "../../_helper/helper";

const OpportunityType: React.FC = () => {
  const dispatch = useAppDispatch();
  const isDrawerOpen = useAppSelector((state) => state.drawer.open);
  const drawerName = useAppSelector((state) => state.drawer.name);
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  useEffect(() => {
    dispatch(getAllOpportunityType());
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  return (
    <>
      <DeleteOpportunityTypeDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Opportunity Type List
          </Typography.h4>
          {isAddAccess && (
            <ButtonCreate
              label="Create Opportunity Type"
              drawerName="opportunityTypeForm"
            />
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <OpportunityTypeGridComponent />
        </GridLayoutItem>
        {isDrawerOpen && drawerName === "opportunityTypeForm" && (
          <AppDrawer>
            <CreateOpportunityType />
          </AppDrawer>
        )}
      </GridLayout>
    </>
  );
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const OpportunityTypeGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const OpportunityTypeList = useAppSelector(
    (state) => state.opportunityType.OpportunityTypeList
  );
  const loading = useAppSelector((state) => state.opportunityType.loading);
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All"
        ? OpportunityTypeList.length
        : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  if (loading) return <LoadingPanel gridRef={gridRef} />;

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleOpenDeleteDialog = (OpportunityTypeGUID: any) => {
      dispatch(openDialog("deleteOpportunityType"));
      dispatch(setOpportunityTypeID(OpportunityTypeGUID));
    };
    return (
      <td
        className="action-td"
        style={{
          ...props.style,
        }}
      >
        {isEditAccess && (
          <ButtonEdit
            ID={props.dataItem?.OpportunityTypeGUID}
            drawerName="opportunityTypeForm"
            title="Edit"
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
themeColor="error"
            onClick={() =>
              handleOpenDeleteDialog(props.dataItem?.OpportunityTypeGUID)
            }
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className="table-header"
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const MyActiveInActtiveCommandCell = (props: GridCellProps) => {
    const [IsActive, setIsActive] = useState<boolean>(props.dataItem?.IsActive);

    const handleActiveInActive = () => {
      setIsActive(!IsActive);
      const data = {
        OpportunityTypeGUID: props.dataItem?.OpportunityTypeGUID,
        IsActive: !IsActive,
      };
      dispatch(OpportunityTypeActiveInactive(data)).then((response: any) => {
        if (response.payload?.data?.Status === 200) {
          dispatch(getAllOpportunityType());
        } else {
          dispatch(getAllOpportunityType());
        }
      });
    };

    return (
      <td style={{ textAlign: "center" }}>
        <Switch
          name="IsActive"
          checked={IsActive}
          disabled={isEditAccess ? false : true}
          onChange={handleActiveInActive}
          size="small"
        />
      </td>
    );
  };

  return (
    <>
      {OpportunityTypeList && OpportunityTypeList.length ? (
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 152px)" }}
 className="responsive-table"
          filterable={true}
          filter={filter}
          data={
            filter
              ? filterBy(OpportunityTypeList, filter).slice(
                  page.skip,
                  page.take + page.skip
                )
              : OpportunityTypeList.slice(page.skip, page.take + page.skip)
          }
          onFilterChange={handleFilterChange}
          skip={page.skip}
          take={page.take}
          total={OpportunityTypeList.length}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 15, "All"],
            pageSizeValue: pageSizeValue,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column
            field="OpportunityType"
            title="Opportunity Type"
            cell={(props: any) => (
              <td className="hoverableName">
                {isEditAccess ? (
                  <ButtonEdit
                    ID={props.dataItem?.OpportunityTypeGUID}
                    drawerName="opportunityTypeForm"
                    label={props.dataItem?.OpportunityType}
                  />
                ) : (
                  props.dataItem?.OpportunityType
                )}
              </td>
            )}
          />
          <Column
            field="OpportunityTypeGUID"
            title="Status"
            cell={MyActiveInActtiveCommandCell}
            width={"90px"}
            filterable={false}
            locked={true}
          />
          {(isDeleteAccess || isEditAccess) && (
            <Column
              field="OpportunityTypeGUID"
              title="Actions"
              cell={MyEditCommandCell}
              width={"110px"}
              filterable={false}
            />
          )}
        </KendoGrid>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

const DeleteOpportunityTypeDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const OpportunityTypeID = useAppSelector(
    (state) => state.opportunityType.OpportunityTypeID
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const handleDeleteAction = async (OpportunityTypeGUID: any) => {
    if (OpportunityTypeGUID) {
      const response = await dispatch(
        deleteOpportunityType(OpportunityTypeGUID)
      );
      if (response.payload?.Data.Status === 200) {
        dispatch(getAllOpportunityType());
        dispatch(closeDialog());
        dispatch(clearOpportunityTypeID());
      } else {
        dispatch(getAllOpportunityType());
        dispatch(closeDialog());
        dispatch(clearOpportunityTypeID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteOpportunityType" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Opportunity Type?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Opportunity Type?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(OpportunityTypeID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default OpportunityType;
